<div (click)="cart == 'cart_sidebar' && cartToggle(true)">
  <i class="ri-shopping-cart-line"></i>
</div>
@if(cartItemDetailList.length){
  <span class="cart_qty_cls">{{ cartItemDetailList.length }}</span>
}
  <!-- Add to cart bar -->
  <div id="cart_side" style="border-left: 1px solid #eee;" [ngClass]="{ 'add_to_cart right right-cart-box': cart == 'cart_sidebar', 'show-div shopping-cart': cart == 'cart_mini' }" [class.open-side]="(sidebarCartOpen$ | async)">
    <div class="cart-inner">
      <div class="cart_top">
        <h3>{{ 'my_cart' | translate }} <span>({{ cartItemDetailList.length }})</span>
        </h3>
        @if(cart == 'cart_sidebar'){
          <div class="close-cart">
            <a href="javascript:void(0)" (click)="cartToggle(false)">
              <i class="ri-close-fill"></i>
            </a>
          </div>
        }
      </div>

      <!-- @if(cartItemDetailList.length){
        <div class="pere-text-box success-box">
          @if(shippingFreeAmt > cartTotal){
            <p>
                {{ 'spend' | translate }} <span class="shipping">{{ (shippingFreeAmt - cartTotal) | currencySymbol }}</span> {{ 'more_and_enjoy' | translate }} <span class="shipping">{{ 'free_shipping' | translate }}!</span>
            </p>
          }@else {
            <p><span class="shipping">{{ 'congratulations' | translate }}!</span> {{ 'enjoy_free_shipping_on_us' | translate }}!</p>
          }
          <div class="progress"
              [ngClass]="{ 'danger-progress': shippingCal <= 30, 'warning-progress': shippingCal >= 31 && shippingCal <= 80 }">
              <div class="progress-bar progress-bar-striped progress-bar-animated"
                  role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"
                  [ngStyle]="{ width: shippingCal+'%' }">
              <i class="ri-truck-line"></i>
              </div>
          </div>
        </div>
      } -->
      <!-- @if(cartItemDetailList.length){
        <div class="sidebar-title">
          <a href="javascript:void(0)" (click)="clearCart()">{{ 'clear_cart' | translate }}</a>
        </div>
      } -->
      <div class="cart_media" [class.empty-cart]="!cartItemDetailList.length">
        <ul class="cart_product">
          @for(item of cartItemDetailList; track item){
            <li>
              <div class="media">
                <a href="javascript:void(0)">
                  <img [src]="item?.FileNameUrl
                                        ? item?.FileNameUrl
                                        : 'assets/images/placeholder/product.png'" class="" [alt]="item?.ProductName">
                </a>
                <div class="media-body">
                  <a href="javascript:void(0)">
                    <h4>{{ item?.ProductName }}</h4>
                  </a>
                  <h4 class="quantity">
                    <span>{{ item?.Quantity }} x {{ item?.SellingPrice }} : {{ item?.TotalPrice ? '₹'+item?.TotalPrice : '' }} </span>
                  </h4>
                  <!-- @if(item?.variation){
                    <h5 class="gram">{{ item?.variation?.selected_variation }}</h5>
                  } -->
                  <div class="qty-box">
                    <div class="input-group">
                      <span class="input-group-prepend">
                        <app-button
                          [type]="'button'"
                          [class]="'btn quantity-left-minus'"
                          [id]="'add-to-cart'+item.ProductId"
                          (click)="item.Quantity <= 1 ? deleteProductToCart(item) :updateQuantity(item, -1)"
                          [spinner]="false">
                          @if(item.Quantity > 1){
                            <i class="ri-subtract-line"></i>
                          }
                          @if(item.Quantity <= 1){
                            <i class="ri-delete-bin-line"></i>
                          }
                        </app-button>
                      </span>
                      <input class="form-control input-number qty-input" type="number" name="quantity" [value]="item?.Quantity" readonly>
                      <span class="input-group-prepend">
                        <app-button
                          [type]="'button'"
                          [class]="'btn quantity-right-plus'"
                          [id]="'qty-left-minus'+item.ProductId"
                          (click)="updateQuantity(item, 1)"
                          [spinner]="false">
                          <i class="ri-add-line"></i>
                        </app-button>
                      </span>
                    </div>
                  </div>
                  <div class="close-circle">
                    <app-button
                      [class]="'delete-button close_button'"
                      [id]="'cart_item_delete_btn'+item.ProductId"
                      [spinner]="false"
                      [iconClass]="'ri-delete-bin-line'"
                      (click)="deleteProductToCart(item)">
                    </app-button>
                  </div>
                </div>
              </div>
            </li>
          }@empty {
            <div class="empty-cart-box">
              <div>
              <i class="ri-shopping-cart-line"></i>
              <h5>{{ 'no_cart_item_desccription' | translate }}</h5>
              </div>
            </div>
          }
        </ul>
        @if(cartItemDetailList.length){
          <ul class="cart_total">
            <li>
              <div class="total">
                <h5>{{ 'subtotal' | translate }} : <span>{{ totalPrice > 0 ? '₹'+totalPrice : 0 }}</span></h5>
              </div>
            </li>
            <li>
              <div class="buttons">
                <a href="javascript:void(0)" class="btn view-cart" [routerLink]="['/cart']" (click)="cartToggle(false)">{{ 'view_cart' | translate }}</a>
                <a href="javascript:void(0)" class="btn checkout" [routerLink]="['/checkout']" (click)="cartToggle(false)">{{ 'checkout' | translate }}</a>
              </div>
            </li>
          </ul>
        }
      </div>
    </div>
  </div>
  <!-- Add to cart bar end-->
   
<!-- Free Shipping Celebration -->
<!-- <div class="confetti-wrapper" [class.show]="confetti == 1 && (sidebarCartOpen$ | async)" *ngIf="(themeOption$ | async)?.general?.celebration_effect">
  <ng-container *ngFor="let item of confettiItems">
      <div class="confetti-{{item}}"></div>
  </ng-container>
</div> -->